import LOQED from './LOQED.js';
export const Loqed = { LOQED: LOQED };
